import React, { RefObject, useRef } from 'react';
import { OptionsProps, OptionType } from '../../types';
import { isEllipsisActive } from '../../utils/isEllipsisActive';
import { SelectOption } from './Option.styles';

type OptionProps = {
  isSelected: boolean;
  option: OptionType;
  activeItemRef: RefObject<HTMLDivElement>;
} & Pick<OptionsProps, 'onSelect' | 'selectSize'>;

export const Option = ({
  isSelected,
  onSelect,
  option,
  selectSize,
  activeItemRef,
}: OptionProps) => {
  const ref = useRef();
  const optionRef = isSelected ? activeItemRef : ref;
  return (
    <SelectOption
      key={option.label}
      role="option"
      aria-selected={isSelected}
      optionVariant={isSelected ? 'selected' : 'primary'}
      onClick={(e) => onSelect(e, option)}
      selectSize={selectSize}
      color={option.color}
      divider={option.divider}
      ref={optionRef}
      title={isEllipsisActive(optionRef) ? option.label : null}
    >
      {option.label}
    </SelectOption>
  );
};
